module.exports = __webpack_public_path__ + "static/media/close.6f077d45.svg";